import React from 'react';
import { connect } from 'react-redux';

import {
    Spacer,
} from '@zillow/constellation';

import BuildingAttributes from 'app/shared/components/postingPath/BuildingAttributes';
import ContactInformation from 'app/shared/components/postingPath/ContactInformation';
import FloorplansMF from 'app/shared/components/postingPath/FloorplansMF';
import HousingConnector from 'app/shared/components/postingPath/HousingConnector';
import ListingDetailsMF from 'app/shared/components/postingPath/ListingDetailsMF';
import ListingStatusBanner from 'app/shared/components/postingPath/ListingStatusBanner';
import Media from 'app/shared/components/postingPath/Media';
import PropertyAmenities from 'app/shared/components/postingPath/PropertyAmenities';
import SpecialOffers from 'app/shared/components/postingPath/SpecialOffers';
import UnitAmenities from 'app/shared/components/postingPath/UnitAmenities';
import userUtils from 'app/shared/utils/userUtils';

import PropertyConstants from 'app/shared/constants/PropertyConstants';

const { SYNDICATION_OVERVIEW_STATUS } = PropertyConstants;

import { AppSelectors, UserSelectors } from 'app/shared/selectors';

import { StyledHR } from 'app/shared/StyledComponents/StyledComponents';

const MultiFamilyForm = ({
    contactNameRef,
    contactPhoneRef,
    descriptionRef,
    errorObj,
    floorplansRef,
    formData,
    forRentByRef,
    getActiveFloorplanOrUnitCount,
    immediateUpdateAndSave,
    isAddingUnit,
    isInputFormDisabled,
    isListingPhotoProcessing,
    isScreenSM,
    isScreenXS,
    isSeattleHousingConnector,
    listingTitleRef,
    photosRef,
    propertyId,
    saveFloorplanData,
    savePropertyData,
    statusMessage,
    updateErrorObj,
    updateFormData,
    updateListingPhotoProcessingStatus,
    updateOnFocus,
    updateParentFloorplanPrice,
    updateStatusMessage,
    user,
    validateFloorplan,
    validateFloorplans,
    validateUnit,
}) => {
    const {
        seattleHousingConnectorStatus,
        syndication,
    } = formData;
    const { roles, isEnterpriseCustomer } = user;
    const isAdmin = userUtils.isPostingPathAdmin(roles);
    const isPaymentRequired = Boolean(formData.paidInclusion && formData.paidInclusion.isPaymentRequired);

    return (
        <div>
            <Spacer marginBottom="xl">

                {(syndication.status !== SYNDICATION_OVERVIEW_STATUS.INACTIVE) && (
                    <ListingStatusBanner universal={syndication.universal} />
                )}
                <ListingDetailsMF
                    errorObj={errorObj}
                    formData={formData}
                    isListingPhotoProcessing={isListingPhotoProcessing}
                    propertyId={propertyId}
                    savePropertyData={savePropertyData}
                    updateErrorObj={updateErrorObj}
                    updateFormData={updateFormData}
                    updateOnFocus={updateOnFocus}
                    updateStatusMessage={updateStatusMessage}
                    isPostingPathAdmin={isAdmin}
                    isEnterpriseCustomer={isEnterpriseCustomer}
                    isInputFormDisabled={isInputFormDisabled}
                    descriptionRef={descriptionRef}
                    listingTitleRef={listingTitleRef}
                />
                <div ref={photosRef} />
                <Media
                    errorObj={errorObj}
                    formData={formData}
                    hasError={Boolean(errorObj.photos)}
                    isListingPhotoProcessing={isListingPhotoProcessing}
                    updateListingPhotoProcessingStatus={updateListingPhotoProcessingStatus}
                    updateFormData={updateFormData}
                    updateErrorObj={updateErrorObj}
                    updateStatusMessage={updateStatusMessage}
                    statusMessage={statusMessage}
                    isInputFormDisabled={isInputFormDisabled}
                    tours={formData.tours}
                    tourType="amenity"
                />
                <StyledHR />
                <div ref={floorplansRef} />
                <FloorplansMF
                    errorObj={errorObj}
                    formData={formData}
                    getActiveFloorplanOrUnitCount={getActiveFloorplanOrUnitCount}
                    isAddingUnit={isAddingUnit}
                    isInputFormDisabled={isInputFormDisabled}
                    isListingPhotoProcessing={isListingPhotoProcessing}
                    isMobile={isScreenXS || isScreenSM}
                    isPostingPathAdmin={isAdmin}
                    propertyId={propertyId}
                    saveFloorplanData={saveFloorplanData}
                    updateErrorObj={updateErrorObj}
                    updateFormData={updateFormData}
                    updateListingPhotoProcessingStatus={updateListingPhotoProcessingStatus}
                    updateOnFocus={updateOnFocus}
                    updateParentFloorplanPrice={updateParentFloorplanPrice}
                    updateStatusMessage={updateStatusMessage}
                    validateFloorplan={validateFloorplan}
                    validateFloorplans={validateFloorplans}
                    validateUnit={validateUnit}
                />
                <StyledHR />
                <SpecialOffers
                    specialOffers={formData.specialOffers}
                    updateFormData={updateFormData}
                    isInputFormDisabled={isInputFormDisabled}
                />
                <StyledHR />
                <ContactInformation
                    contactNameRef={contactNameRef}
                    contactPhoneRef={contactPhoneRef}
                    errorObj={errorObj}
                    formData={formData}
                    forRentByRef={forRentByRef}
                    immediateUpdateAndSave={immediateUpdateAndSave}
                    isInputFormDisabled={isInputFormDisabled}
                    isPaymentRequired={isPaymentRequired}
                    savePropertyData={savePropertyData}
                    updateErrorObj={updateErrorObj}
                    updateFormData={updateFormData}
                    updateOnFocus={updateOnFocus}
                    updateStatusMessage={updateStatusMessage}
                />
                <StyledHR />
                <PropertyAmenities
                    errorObj={errorObj}
                    updateErrorObj={updateErrorObj}
                    formData={formData}
                    immediateUpdateAndSave={immediateUpdateAndSave}
                    propertyId={propertyId}
                    updateFormData={updateFormData}
                    updateStatusMessage={updateStatusMessage}
                    isInputFormDisabled={isInputFormDisabled}
                />
                <StyledHR />
                <BuildingAttributes
                    errorObj={errorObj}
                    formData={formData}
                    immediateUpdateAndSave={immediateUpdateAndSave}
                    savePropertyData={savePropertyData}
                    updateErrorObj={updateErrorObj}
                    updateFormData={updateFormData}
                    updateOnFocus={updateOnFocus}
                    updateStatusMessage={updateStatusMessage}
                    userRoles={roles}
                    isInputFormDisabled={isInputFormDisabled}
                />
                <StyledHR />
                <UnitAmenities
                    errorObj={errorObj}
                    updateErrorObj={updateErrorObj}
                    formData={formData}
                    immediateUpdateAndSave={immediateUpdateAndSave}
                    propertyId={propertyId}
                    updateFormData={updateFormData}
                    updateStatusMessage={updateStatusMessage}
                    isInputFormDisabled={isInputFormDisabled}
                />
                {isSeattleHousingConnector && (
                    <React.Fragment>
                        <StyledHR />
                        <HousingConnector
                            initSelectedOption={seattleHousingConnectorStatus}
                            handleSelectChange={immediateUpdateAndSave}
                        />
                    </React.Fragment>
                )}
            </Spacer>
        </div>
    );
};

const mapStateToProps = state => ({
    isSeattleHousingConnector: UserSelectors.makeIsSeattleHousingConnector(state),
    isScreenXS: AppSelectors.makeIsScreenXS(state),
    isScreenSM: AppSelectors.makeIsScreenSM(state),
    user: UserSelectors.makeUser(state),
});

export { MultiFamilyForm };
export default connect(mapStateToProps)(MultiFamilyForm);
